import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';
import * as S from '~/widgets/company-to-theme-widget/CompanyToThemeWidget.styles';

import { CountryExposureDrawerContent } from './tabs/country-exposure-tab/CountryExposureDrawerContent';
import { RegionExposureDrawerContent } from './tabs/region-exposure-tab/RegionExposureDrawerContent';

export interface CompanyToGeoWidgetProps {
  entity: Entity;
}

export const CompanyToGeoWidget = ({ entity }: CompanyToGeoWidgetProps) => {
  const { params } = useQueryParams();
  const countryCode = params[queryKeys.countryCode];

  return (
    <S.Container>
      <ErrorBoundaryWrapper>
        {countryCode ? (
          <CountryExposureDrawerContent entity={entity} />
        ) : (
          <RegionExposureDrawerContent entity={entity} />
        )}
      </ErrorBoundaryWrapper>
    </S.Container>
  );
};
